import { Component, OnInit } from '@angular/core';
import { Menu } from '../../models/menu.model';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
  menus: Menu[] = [];

  constructor(private adminService: AdminService) { }

    ngOnInit() {
      this.menus = [
        new Menu('Training', '', [
          new Menu('Training Videos', 'help/training-videos'),
        ]),
        new Menu('Frequently asked questions', '', [
          new Menu('FAQ', 'help/faqs'),
          new Menu('FAQ Categories', 'help/faqscategory'),
        ]),
        new Menu('Changelogs', '', [
          new Menu('Changelogs', 'help/faqssss')
        ])
      ];

      this.adminService.loadMenu(this.menus);
    }
    
}



// WEBPACK FOOTER //
// ./src/app/admin/help/help.component.ts